'use client';
import { Tabs as SharedTabs } from '@launchstore/shared-puck';
import type { TabsProps } from '@launchstore/shared-puck';
export const Tabs: any = SharedTabs;
export type { TabsProps };
export default Tabs;
